import {useQuery} from "@tanstack/react-query";
import apiClient from "../../services/apiClient";

const useFetchFooter = () => useQuery({
    queryKey: ['footer'],
    queryFn: async () =>
        apiClient
            .get('/page/8')
            .then(res => res.data)
    ,
});

export default useFetchFooter;

